import * as Yup from "yup";
import formToObject from "form-to-object";

class FormManager {
  constructor(el) {
    this.el = el;
  }

  omitFields = ["submitButton", "oid", "retURL"];

  schema = Yup.object().shape({
    first_name: Yup.string().required(),
    last_name: Yup.string().required(),
    email: Yup.string().email().required(),
    country: Yup.string().required()
  });

  // -- VALIDATION -- //

  reCaptchaError() {
    return {
      errors: ["You must confirm that you are not a robot"],
      message: "You must confirm that you are not a robot",
      path: "imahuman"
    };
  }

  cleanedFormToObject = form => {
    const values = formToObject(form);
    return Object.keys(values)
      .filter(k => !this.omitFields.includes(k))
      .reduce((acc, key) => ((acc[key] = values[key]), acc), {});
  };

  async validateSchema(form, doSubmit = false) {
    const values = this.cleanedFormToObject(form);

    this.schema
      .validate(values, { abortEarly: false })
      .then(result => {
        if (!grecaptcha.getResponse()) throw { inner: [] };
        if (doSubmit) form.submit();
      })
      .catch(err => {
        this.showFormErrors(form, err);
      });
  }

  // -- RENDER -- //

  showFormErrors(form, errors) {
    // Add reCaptcha error if no response token is available
    if (!grecaptcha.getResponse()) errors.inner.push(this.reCaptchaError());

    // Remove any previous errors
    form.querySelectorAll(".field-error").forEach(el => el.remove());
    form
      .querySelectorAll(".input-error")
      .forEach(el => el.classList.remove("input-error"));

    // Display any errors
    errors.inner.forEach(error => {
      const input = form.elements[error.path];
      const messageStr = error.message.replace(
        `${error.path}`,
        input.placeholder
      );

      const message = document.createElement("p");
      message.classList.add("field-error");
      message.textContent = `${messageStr}`;

      form.elements[error.path].after(message);
      input.classList.add("input-error");
    });
  }

  // -- INIT -- //

  init = () => {
    if (this.el) {
      this.el.addEventListener("submit", evt => {
        evt.preventDefault();
        this.validateSchema(this.el, true);
      });
    }
  };
}

export default FormManager;
